import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    position: 'relative',

    width: '100%',
    height: '52px',
    borderRadius: '60px !important',
  }
}));

export default useStyles;
